import { render, staticRenderFns } from "./Contact-Persons.vue?vue&type=template&id=189f0540&scoped=true"
import script from "./Contact-Persons.vue?vue&type=script&lang=js"
export * from "./Contact-Persons.vue?vue&type=script&lang=js"
import style0 from "./Contact-Persons.vue?vue&type=style&index=0&id=189f0540&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "189f0540",
  null
  
)

export default component.exports